<template>
    <div class="contact__head contact-toggle">
        <div class="contact-toggle__title h2 block">Контактная информация</div>
        <div class="contact-toggle__info contact-info block">
            <div id="contact-fl" class="contact-info__item">
                <div class="contact-info__label h3">Физ.лица:</div>
                <div class="contact-info__phone h3">
                    <a :href="getFlPhone" class="link link--pseudo">
                        <span class="link__text">{{ contactFl.ContactsCallCenter }}</span>
                    </a>
                </div>
                <div class="contact-info__time h3">{{ contactFl.WorkingTimeCallCenter }}</div>
            </div>
            <div id="contact-ul" class="contact-info__item">
                <div class="contact-info__label h3">Юр.лица:</div>
                <div class="contact-info__phone h3">
                    <a :href="getUlPhone" class="link link--pseudo">
                        <span class="link__text">{{ contactUl.ContactsCallCenter }}</span>
                    </a>
                </div>
                <div class="contact-info__time h3">{{ contactUl.WorkingTimeCallCenter }}</div>
            </div>
            <div id="contact-sts" class="contact-info__item">
                <div class="contact-info__label h3">Подключение к сетям:</div>
                <div class="contact-info__phone h3">
                    <a :href="getSTSPhone" class="link link--pseudo">
                        <span class="link__text">{{ stsContactsCOK }}</span>
                    </a>
                </div>
                <div class="contact-info__time h3">{{ stsWorkingTime }}</div>
            </div>
        </div>
        <div class="contact-toggle__ctrl block">
            <a href="#contactBody" id="footerContactInfo" class="collapse-link link link--underline collapsed" data-toggle="collapse">
                <!--<span class="link__text">Все контакты</span>-->
                <span class="link__icon fab-icon">
                    <i class="icon icon--angle-down"></i>
                </span>
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            contactFl: Object,
            contactUl: Object,
            contactSTS: Object,
        },
		data: function () {
			return {	
                isContactSTS: true,
                stsContactsCOK: "",
                stsWorkingTime: ""
			}
		},
        computed: {
            getFlPhone() {
                return "tel:" + this.contactFl.ContactsCallCenter.replace(/[^\d]/g, '')
            },
            getUlPhone() {
                return "tel:" + this.contactUl.ContactsCallCenter.replace(/[^\d]/g, '')
            },
            getSTSPhone() {
                var phone = "tel:";
                this.isContactSTS = false;
				if (this.contactSTS != "undefined" && this.contactSTS!=null) {
                    phone = phone + this.contactSTS.ContactsCOK.replace(/[^\d]/g, '');
                    this.isContactSTS = true;
					this.stsContactsCOK = this.contactSTS.ContactsCOK;
					this.stsWorkingTime = this.contactSTS.WorkingTime;
                }
                return phone;
                //return "tel:" + this.contactSTS.ContactsCOK.replace(/[^\d]/g, '')
            }
        }
    }

    $(function () {
		let loc = window.location.pathname;
		let sing = loc.includes("STS");

		let contactFl = document.getElementById('contact-fl');
		let contactUl = document.getElementById('contact-ul');
		let contactSts = document.getElementById('contact-sts');
		if (sing) {
			if (contactFl) contactFl.style.display = 'none';
			if (contactUl) contactUl.style.display = 'none';
			if (contactSts) contactSts.style.display = '';
		}
		else {
			if (contactFl) contactFl.style.display = '';
			if (contactUl) contactUl.style.display = '';
			if (contactSts) contactSts.style.display = 'none';
		}
    });
</script>


// WEBPACK FOOTER //
// Scripts/app/FooterContactInfo/FooterContactHead.vue